var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.714286 3.67347H19.2857C19.6802 3.67347 20 3.30801 20 2.85714V0.816327C20 0.365459 19.6802 0 19.2857 0H0.714286C0.319777 0 0 0.365459 0 0.816327V2.85714C0 3.30801 0.319777 3.67347 0.714286 3.67347ZM0.714286 11.8367H19.2857C19.6802 11.8367 20 11.4713 20 11.0204V8.97959C20 8.52872 19.6802 8.16327 19.2857 8.16327H0.714286C0.319777 8.16327 0 8.52872 0 8.97959V11.0204C0 11.4713 0.319777 11.8367 0.714286 11.8367ZM0.714286 20H19.2857C19.6802 20 20 19.6345 20 19.1837V17.1429C20 16.692 19.6802 16.3265 19.2857 16.3265H0.714286C0.319777 16.3265 0 16.692 0 17.1429V19.1837C0 19.6345 0.319777 20 0.714286 20Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.dd1b9900.svg";
export { ForwardRef as ReactComponent };